import {createStore} from "redux";
import allReducers from "./reducers";
import {composeWithDevTools} from "redux-devtools-extension";
import {persistStore} from "redux-persist";

export const store = createStore(allReducers,composeWithDevTools());

export const persistor = persistStore(store);

export default {store, persistor}